import SectionLabel from '@/components/feature/SectionLabel';

export default function Philosophy() {
  return (
    <section id="philosophy" className="py-20 md:py-32 scroll-mt-16">
      <div className="shell grid grid-cols-1 lg:grid-cols-12 gap-x-6 gap-y-10">
        <div className="lg:col-span-3">
          <SectionLabel index="01">Philosophy</SectionLabel>
        </div>
        <h2 data-reveal="title" className="lg:col-span-8 lg:col-start-4 display text-[clamp(2.1rem,4.6vw,4.4rem)] leading-[1.06]">
          A surface is never just a surface. It is material, pigment and light, held together by the hand that applied
          it.
        </h2>
        <div className="lg:col-start-4 lg:col-span-9 grid grid-cols-1 md:grid-cols-9 gap-x-6 gap-y-6 pt-10 md:pt-14 border-t border-background-300">
          <p className="md:col-span-4 text-[15px] leading-relaxed text-foreground-700">
            An exterior wall is the first thing a house says. Its material, its pigment and the way it holds light decide
            how a building is read from the street — at noon, at dusk, in rain.
          </p>
          <p className="md:col-span-4 md:col-start-6 text-[15px] leading-relaxed text-foreground-700">
            MATERA works only on exterior surfaces. We repair what is underneath first, choose finishes the wall can
            actually take, and apply them by hand with the patience the material asks for.
          </p>
        </div>
      </div>
    </section>
  );
}